/* tuningheld · Theme JS v3 (light) */
(function () {
  'use strict';

  /* ── TOAST ───────────────────────── */
  function showToast(msg, icon) {
    var t = document.getElementById('sf-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'sf-toast';
      t.className = 'sf-toast';
      t.innerHTML = '<div class="toast-dot" id="toast-icon"></div><span id="toast-msg"></span>';
      document.body.appendChild(t);
    }
    document.getElementById('toast-icon').textContent = icon || '\u2713';
    document.getElementById('toast-msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('show'); }, 3000);
  }
  window.showToast = showToast;

  /* ── ADD TO CART (Legacy-Produktgrid) ── */
  window.addToCart = function (btn, variantId, qty) {
    if (!variantId) { showToast('Produkt nicht verf\u00FCgbar', '\u26A0\uFE0F'); return; }
    var origHTML = btn ? btn.innerHTML : '';
    if (btn) { btn.innerHTML = '<span class="btn-spinner"></span>'; btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Fehler'); });
      showToast('Im Warenkorb!', '\u2713');
      if (btn) btn.innerHTML = '\u2713 Hinzugef\u00FCgt';
      setTimeout(function () { window.location.href = '/cart'; }, 650);
    }).catch(function (err) {
      showToast(err.message || 'Fehler beim Hinzuf\u00FCgen', '\u26A0\uFE0F');
      if (btn) { btn.innerHTML = origHTML; btn.disabled = false; }
    });
  };

  /* ── PRODUKT-FILTER (Legacy-Grid) ── */
  window.filterProducts = function (btn, cat) {
    document.querySelectorAll('.filter-btn').forEach(function (b) { b.classList.remove('active'); });
    btn.classList.add('active');
    document.querySelectorAll('.product-card[data-cat]').forEach(function (c) {
      c.style.display = (cat === 'all' || c.dataset.cat === cat) ? '' : 'none';
    });
  };

  /* ── FAQ-AKKORDEON (Legacy-Section) ── */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq-q');
    if (!q) return;
    var item = q.closest('.faq-item');
    if (!item) return;
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
    if (!isOpen) item.classList.add('open');
  });

  /* ── SCROLL-REVEAL ───────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── COUNTDOWN (CTA-Banner) ──────── */
  function initCountdown() {
    var h = document.getElementById('cd-h');
    var m = document.getElementById('cd-m');
    var s = document.getElementById('cd-s');
    if (!h) return;
    var KEY = 'sf_offer_exp';
    var exp = 0;
    try { exp = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!exp || exp < now) {
      exp = now + 3 * 3600 * 1000;
      try { localStorage.setItem(KEY, String(exp)); } catch (e) {}
    }
    var tick = function () {
      var d = Math.max(0, Math.floor((exp - Date.now()) / 1000));
      h.textContent = String(Math.floor(d / 3600)).padStart(2, '0');
      m.textContent = String(Math.floor((d % 3600) / 60)).padStart(2, '0');
      s.textContent = String(d % 60).padStart(2, '0');
    };
    tick(); setInterval(tick, 1000);
  }

  /* ── INIT ────────────────────────── */
  function init() { initReveal(); initCountdown(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

})();

/* ── SF DYNAMIC RECOMMENDATIONS + RECENTLY VIEWED ── */
(function(){
  function esc(s){return String(s||'').replace(/[&<>'"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c];});}
  function money(cents){try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(cents/100);}catch(e){return (cents/100).toFixed(2).replace('.',',')+' €';}}
  function card(p){var img=(p.featured_image&&p.featured_image.url)||p.image||'';var vid=p.variants&&p.variants[0]?p.variants[0].id:'';return '<article class="sf-up-card"><a class="sf-up-card__img" href="'+esc(p.url)+'">'+(img?'<img loading="lazy" src="'+esc(img)+'&width=600" alt="'+esc(p.title)+'">':'')+'</a><div class="sf-up-card__body"><a class="sf-up-card__title" href="'+esc(p.url)+'">'+esc(p.title)+'</a><div class="sf-up-card__price">'+(p.price||money(p.price_min||0))+'</div>'+(vid?'<button type="button" class="sf-up-card__btn" data-sf-quick-add="'+vid+'">Hinzufügen</button>':'<a class="sf-up-card__btn" href="'+esc(p.url)+'">Ansehen</a>')+'</div></article>';}
  function initRecs(){document.querySelectorAll('[data-product-id][data-sf-recommendations], .sf-upsell[data-product-id]').forEach(function(section){var grid=section.querySelector('[data-sf-recommendations]');if(!grid||grid.dataset.loaded)return;grid.dataset.loaded='1';var id=section.getAttribute('data-product-id');fetch('/recommendations/products.json?product_id='+encodeURIComponent(id)+'&limit=6&intent=related').then(function(r){return r.json();}).then(function(d){var ps=(d.products||[]).slice(0,6);grid.innerHTML=ps.length?ps.map(card).join(''):'<div class="sf-upsell__empty">Für dieses Produkt sind aktuell keine weiteren Empfehlungen hinterlegt.</div>';}).catch(function(){grid.innerHTML='';});});}
  function initRecent(){var raw=document.getElementById('sf-current-product-json');if(!raw)return;var current;try{current=JSON.parse(raw.textContent);}catch(e){return;}var key='sf_recent_products',arr=[];try{arr=JSON.parse(localStorage.getItem(key)||'[]');}catch(e){}var older=arr.filter(function(x){return String(x.id)!==String(current.id);}).slice(0,3);var sec=document.querySelector('[data-sf-recent-section]'),grid=document.querySelector('[data-sf-recent-grid]');if(sec&&grid&&older.length){grid.innerHTML=older.map(card).join('');sec.hidden=false;}arr=[current].concat(older).slice(0,4);try{localStorage.setItem(key,JSON.stringify(arr));}catch(e){}
  }
  document.addEventListener('click',function(e){var b=e.target.closest('[data-sf-quick-add]');if(!b)return;b.disabled=true;var old=b.textContent;b.textContent='Wird hinzugefügt…';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(b.dataset.sfQuickAdd),quantity:1}]})}).then(function(r){if(!r.ok)throw new Error();b.textContent='Hinzugefügt ✓';setTimeout(function(){b.disabled=false;b.textContent=old;},1400);}).catch(function(){b.disabled=false;b.textContent='Erneut versuchen';});});
  function init(){initRecs();initRecent();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
